// extracted by mini-css-extract-plugin
export var section = "NewsSectionBlock-module--section--TD9zu";
export var date = "NewsSectionBlock-module--date--P8Mos";